<script>
  import { createEventDispatcher } from 'svelte';
  const dispatch = createEventDispatcher();
  export let total;
  export let mobile;
</script>

<style style="text/scss" lang="scss">
  .comments-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-top: 0px;
    &.desktop {
      padding-right: 32px;
    }
    .count-container {
      display: flex;
      align-items: center;
      gap: 8px;
      .count-label {
        color: #1a1a1a;
        font-size: 14px;
        font-style: normal;
        font-weight: 400;
        line-height: 20px;
        opacity: 0.5;
      }
      .count-value {
        color: #000;
        font-size: 14px;
        font-style: normal;
        font-weight: 400;
        line-height: 12px;
      }
    }
    .close-button-container {
      display: flex;
      width: 32px;
      height: 32px;
      padding: 8px;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      gap: 8px;
      flex-shrink: 0;
      cursor: pointer;
    }
  }
</style>

<div class="comments-header {mobile ? 'mobile' : 'desktop'}">
  <div class="count-container">
    {#if total > 0}
      <div class="count-label">Comments</div>
      <div class="count-value">{total}</div>
    {:else if !mobile}
      <div class="count-label">No comments</div>
    {/if}
  </div>
  <div
    class="close-button-container"
    on:click={() => {
      dispatch('closed');
    }}>
    <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 12 12" fill="none">
      <path
        d="M6.08817 4.85052C6.07656 4.86216 6.06277 4.8714 6.04758 4.8777C6.0324 4.884 6.01612 4.88724 5.99968 4.88724C5.98324 4.88724 5.96696 4.884 5.95177 4.8777C5.93659 4.8714 5.92279 4.86216 5.91118 4.85052L1.28056 0.2194C1.13974 0.0787803 0.948833 -0.000140458 0.749826 1.87661e-07C0.550819 0.000140833 0.360019 0.0793311 0.219399 0.22015C0.0787798 0.360968 -0.000140447 0.55188 1.87633e-07 0.750887C0.000140822 0.949894 0.0793309 1.14069 0.220149 1.28131L4.84877 5.91193C4.86041 5.92354 4.86965 5.93734 4.87595 5.95252C4.88225 5.96771 4.88549 5.98399 4.88549 6.00043C4.88549 6.01687 4.88225 6.03315 4.87595 6.04833C4.86965 6.06352 4.86041 6.07731 4.84877 6.08892L0.220149 10.7195C0.150489 10.7892 0.0952246 10.8718 0.057512 10.9628C0.0197994 11.0538 0.000377086 11.1513 0.000353874 11.2498C0.000306992 11.4487 0.07928 11.6395 0.2199 11.7802C0.360519 11.9209 0.551266 12 0.750179 12C0.949092 12 1.13988 11.9211 1.28056 11.7805L5.91118 7.15033C5.92279 7.13869 5.93659 7.12946 5.95177 7.12316C5.96696 7.11686 5.98324 7.11361 5.99968 7.11361C6.01612 7.11361 6.0324 7.11686 6.04758 7.12316C6.06277 7.12946 6.07656 7.13869 6.08817 7.15033L10.7193 11.7805C10.789 11.8501 10.8716 11.9053 10.9626 11.943C11.0537 11.9806 11.1512 12 11.2497 12C11.4486 12 11.6393 11.9209 11.78 11.7802C11.8496 11.7105 11.9048 11.6279 11.9425 11.5368C11.9801 11.4458 11.9995 11.3483 11.9995 11.2498C11.9995 11.0509 11.9204 10.8602 11.7797 10.7195L7.14858 6.08892C7.13694 6.07731 7.12771 6.06352 7.12141 6.04833C7.11511 6.03315 7.11186 6.01687 7.11186 6.00043C7.11186 5.98399 7.11511 5.96771 7.12141 5.95252C7.12771 5.93734 7.13694 5.92354 7.14858 5.91193L11.7797 1.28131C11.9204 1.14069 11.9995 0.949946 11.9995 0.751033C11.9995 0.55212 11.9206 0.361336 11.78 0.22065C11.6393 0.0799639 11.4486 0.00090024 11.2497 0.000853358C11.0508 0.000806476 10.86 0.0797799 10.7193 0.220399L6.08817 4.85052Z"
        fill="black" />
    </svg>
  </div>
</div>
